export default __webpack_public_path__ + "static/media/skewer.95ce62a5.png";